<!--
 * @Description: input 去掉前后空格、状态有 【，】
 disabled:可编辑，不可编辑
 view:true,false =>true:详情 false:不受控制
-->
<template>
  <CosViewTextarea v-bind="$attrs" :value="value" v-if="view" />
  <a-textarea
    v-else
    v-bind="$attrs"
    v-model:value="modelValue"
    :placeholder="placeholder || $t('common.pleaseInput')"
    style="width: 100%"
    @blur="changeTrim"
    :autoSize="autoSize"
  >
    <slot name="prefix"></slot>
    <slot name="suffix"></slot>
  </a-textarea>
</template>
<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import CosViewTextarea from '../CosView/textarea.vue'
const props = defineProps({
  value: {
    type: [String, Number]
  },
  placeholder: {
    type: String
  },
  trim: {
    type: Boolean, // 去掉前后空格
    default: true
  },
  autoSize: {
    type: [Object, Boolean], // 去掉前后空格
    default: () => {
      return { minRows: 2 }
    }
  },
  view: {
    type: Boolean
  }
})
const emit = defineEmits(['update:value'])
const modelValue = useVModel(props, 'value', emit)
const changeTrim = () => {
  if (typeof modelValue.value === 'string' && props.trim) {
    modelValue.value = modelValue.value?.trim()
  }
}
</script>
